import React from 'react';
import './SecurityScore.css';

function SecurityScore() {
  return (
    <div className="page-container">
      <div className="header-section">
        <h1>Security Score</h1>
        <p className="lead">System security and vulnerability assessment</p>
      </div>

      <div className="content-section">
        <div className="row">
          <div className="col-md-4">
            <div className="score-card security">
              <div className="score-header">Security Score</div>
              <div className="score-value">88</div>
              <div className="score-trend positive">
                <i className="bi bi-arrow-up"></i>
                <span>+2 points this month</span>
              </div>
            </div>

            <div className="card risk-summary">
              <div className="card-body">
                <h3>Risk Summary</h3>
                <div className="risk-item">
                  <div className="risk-level low">
                    <i className="bi bi-shield-check"></i>
                    <span>Low Risk</span>
                  </div>
                  <div className="risk-count">3 issues</div>
                </div>
                <div className="risk-item">
                  <div className="risk-level medium">
                    <i className="bi bi-shield-exclamation"></i>
                    <span>Medium Risk</span>
                  </div>
                  <div className="risk-count">2 issues</div>
                </div>
                <div className="risk-item">
                  <div className="risk-level high">
                    <i className="bi bi-shield-fill-exclamation"></i>
                    <span>High Risk</span>
                  </div>
                  <div className="risk-count">0 issues</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-8">
            <div className="card mb-4">
              <div className="card-body">
                <h3>Security Overview</h3>
                <div className="security-metrics">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="security-metric">
                        <div className="metric-label">Vulnerability Scanning</div>
                        <div className="circular-progress high">
                          <div className="progress-value">95%</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="security-metric">
                        <div className="metric-label">Patch Management</div>
                        <div className="circular-progress medium">
                          <div className="progress-value">82%</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="security-metric">
                        <div className="metric-label">Access Control</div>
                        <div className="circular-progress high">
                          <div className="progress-value">90%</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="security-metric">
                        <div className="metric-label">Incident Response</div>
                        <div className="circular-progress high">
                          <div className="progress-value">88%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <h3>Recent Security Events</h3>
                <div className="security-events">
                  <div className="event-item">
                    <div className="event-icon success">
                      <i className="bi bi-check-circle"></i>
                    </div>
                    <div className="event-details">
                      <div className="event-title">Security Patch Update</div>
                      <div className="event-description">Successfully applied latest security patches</div>
                      <div className="event-time">2 hours ago</div>
                    </div>
                  </div>
                  <div className="event-item">
                    <div className="event-icon warning">
                      <i className="bi bi-exclamation-triangle"></i>
                    </div>
                    <div className="event-details">
                      <div className="event-title">Failed Login Attempt</div>
                      <div className="event-description">Multiple failed login attempts detected</div>
                      <div className="event-time">5 hours ago</div>
                    </div>
                  </div>
                  <div className="event-item">
                    <div className="event-icon info">
                      <i className="bi bi-info-circle"></i>
                    </div>
                    <div className="event-details">
                      <div className="event-title">Firewall Rule Update</div>
                      <div className="event-description">Updated firewall configuration</div>
                      <div className="event-time">1 day ago</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SecurityScore;
